//using the old buyer code here for investor migration
import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import SelectSeller from "../../SelectSeller/SelectSeller";
import Textarea from "../../Textarea-new/Textarea";
import SelectBuyer from "../../SelectBuyer/SelectBuyer";
import SelectInvester from "../../SelectSeller/SelectInvester";

const OwnershipInfo = ({isAgent, data, seller, handleChangeDropdown, handleChangeSeller, handleSellerChangeDropdown, handleSellerChangeInput, edit, addNewItem, viewMode, deleted, sellerSelected, newSeller, newBuyer, isFinancing}) => {
    const getSellerLabel=(data)=>{
        if(data&&data.source === "HSC" && (data.loan_type === "Refi" || data.loan_type === "Construction")){
            return "Investor"
        }else{
            return "Seller"
        }
    }
    return (
        <div className="Ownership-info">
            {
                isFinancing &&
                <div className="Ownership-info_column">
                {!(data&&data.source === "HSC" && (data.loan_type === "Refi" || data.loan_type === "Construction")) && <SelectBuyer
                        className="Ownership-info_column_item"
                        isFromProperty
                        value={data.buyer_id}
                        valueKey="buyer_id"
                        label="Buying Investor"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newBuyer={newBuyer}
                    />}
                    <SelectSeller
                        isFromProperty
                        value={data.seller_id}
                        valueKey="seller_id"
                        label={getSellerLabel(data)}
                        data={data}
                        handleParentChange={handleSellerChangeDropdown}
                        withAddNew
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newSeller={newSeller}
                    />
                </div>
            }
            {
                !isFinancing && edit && data.seller_id && !sellerSelected &&
                <div className="Ownership-info_column">
                    <div className="green-title">Investor</div>
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="first_name"
                        label="First Name"
                        value={seller.first_name}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="last_name"
                        label="Last Name"
                        value={seller.last_name}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="phone"
                        name="phone"
                        label="Phone"
                        value={seller.phone}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="email"
                        name="email"
                        label="Email"
                        value={seller.email}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Dropdown
                        className="Ownership-info_column_item"
                        data={seller}
                        isFromProperty
                        optionsType="profiles"
                        value={seller.profile}
                        valueKey="profile"
                        label="Profile"
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Textarea
                        className="Ownership-info_column_item"
                        disabled={isAgent}
                        label="Notes"
                        name="notes"
                        value={seller.notes}
                        maxWidth="100%"
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
            }
            {
                !isFinancing && edit && data.seller_id && !sellerSelected &&
                <div className="Ownership-info_column">
                    <div className="green-title">Investor Company</div>
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="company_name"
                        label="Company Name"
                        value={seller.company_name}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="company_address"
                        label="Company Address"
                        value={seller.company_address}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="company_city"
                        label="City"
                        value={seller.company_city}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Dropdown
                        className="Ownership-info_column_item"
                        data={seller}
                        isFromProperty
                        optionsType="states"
                        optionKey="abbr"
                        optionLabelKey="name"
                        value={seller.company_state}
                        valueKey="company_state"
                        label="State"
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="company_zip"
                        label="Zip"
                        value={seller.company_zip}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
            }
            {
                !viewMode && data.seller_id && !sellerSelected &&
                <div className="Ownership-info_column">               
                    <button className="button-new positive" onClick={handleChangeSeller}>Change Investor</button>
                </div>
            }
            {
                !isFinancing && (!edit || data.seller_id === null || sellerSelected) &&
                <div className="Ownership-info_column">
                    <div className="Ownership-info_column_item">
                        <SelectInvester
                            isFromProperty
                            value={data.seller_id}
                            valueKey="seller_id"
                            label="Selling Investor"
                            data={data}
                            handleParentChange={handleSellerChangeDropdown}
                            withAddNew
                            addNewItem={addNewItem}
                            viewMode={viewMode}
                            deleted={deleted}
                            newSeller={newSeller}
                        />
                    </div>
                </div>
            }
        </div>
    );
};

export default OwnershipInfo;
